<template>
  <div>
    <button v-if="documents.length" class="btn btn-link text-primary text-decoration-none font-weight-bold" @click="toggleSelectAllDocuments" style="position: relative;right:12px ;">{{ allDocumentsSelected ? 'Unselect all document' : 'Select all document' }}</button>
    <v-row>
      <v-col cols="3">
        <div class="library-card border border-dashed d-flex justify-center align-center">
          <div role="button" class="text-center text-primary" @click="openUpload">
            <v-icon class="text-primary">mdi-upload-outline</v-icon><br>
            <span>Upload File</span>
          </div>
          <UploadDocumentModal :dialog="showUpload" @toggle-modal="toggleDialog"/>
        </div>
      </v-col>
      <Card v-for="file in documents" :key="file.id" :file="file" :isSelected="isSelected(file.id)" @toggle-selection="handleToggleSelection"/>
      <BottomActionBar v-if="selectedDocuments.length" :selected-documents="selectedDocuments" @clear-selection="clearSelection" />
    </v-row>
  </div >
</template>
<style>
  .border-dashed {
    border: 2px dashed #848484!important;
    border-radius: 4px;
}
</style>
<script>
import Card from './card.vue'
import BottomActionBar from './bottom_action_bar.vue';
import UploadDocumentModal from './upload-document-modal.vue';

export default {
  components: { Card, BottomActionBar, UploadDocumentModal },
  data: function() {
    return {
      showUpload: false,
      selectedDocuments: [],
    }
  },
  computed: {
    documents() {
      return this.$store.state.documents
    },
    org_id() {
      return this.$store.state.organization.id
    },
    cases() {
      return this.$store.state.cases
    },
    allDocumentsSelected() {
      return this.selectedDocuments.length === this.documents.length;
    }
  },
  methods: {
    openUpload() {
      this.showUpload = true
    },
    toggleDialog(payload) {
      this.showUpload = payload
    },
    toggleSelectAllDocuments() {
      this.selectedDocuments = this.allDocumentsSelected ? [] : this.documents.map(file => file.id);
    },
    handleToggleSelection(fileId, isSelected) {
      if (isSelected) {
        this.selectedDocuments?.push(fileId);
      } else {
        this.selectedDocuments = this.selectedDocuments?.filter(id => id !== fileId);
      }
    },
    isSelected(fileId) {
      return this.selectedDocuments?.includes(fileId);
    },
    clearSelection() {
      this.selectedDocuments = [];
    }
  }
}
</script>
